import moment from 'moment';

export const getIsOptionActive = ({ option, label, text, customButton }) => {
  const selectedValue = text ?? customButton?.props?.value;
  const selectedMoment = moment(selectedValue);
  const selectedTimeValue = selectedMoment.isValid() ? selectedMoment.format('HH:mm') : null;
  const labelMoment =
    typeof label === 'string' ? moment(label.trim(), ['h:mm A', 'h:mmA'], true) : null;
  const labelTimeValue = labelMoment?.isValid() ? labelMoment.format('HH:mm') : null;
  const isSameTime =
    Boolean(selectedTimeValue) &&
    ((option?.value && option.value === selectedTimeValue) ||
      (labelTimeValue && labelTimeValue === selectedTimeValue));

  return label === text || option?.value === selectedValue || isSameTime;
};
